import { useState, useEffect } from 'react';
import { hrApprovalAPI } from '../utils/api';

const overlay = { position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999 };
const modal = { background:'#fff',borderRadius:12,padding:24,width:520,maxHeight:'80vh',overflow:'auto',boxShadow:'0 8px 30px rgba(0,0,0,0.15)' };

const aksiBadge = (aksi) => {
  const map = {
    APPROVE:  { bg:'#DCFCE7', color:'#166534' },
    POSTING:  { bg:'#DCFCE7', color:'#166534' },
    REJECT:   { bg:'#FEE2E2', color:'#991B1B' },
    SUBMIT:   { bg:'#E0E7FF', color:'#3730A3' },
  };
  const c = map[aksi] || { bg:'#F3F4F6', color:'#374151' };
  return <span style={{ padding:'2px 8px',borderRadius:4,fontSize:11,fontWeight:600,...c }}>{aksi}</span>;
};

export default function ApprovalHistoryModal({ module, referenceId, onClose }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!module || !referenceId) return;
    setLoading(true);
    hrApprovalAPI.getHistory(module, referenceId)
      .then(r => setData(r.data || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [module, referenceId]);

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16 }}>
          <h3 style={{ margin:0,fontSize:16,fontWeight:700 }}>Riwayat Approval</h3>
          <button onClick={onClose} style={{ border:'none',background:'none',fontSize:18,cursor:'pointer',color:'#6B7280' }}>&times;</button>
        </div>
        {loading ? <p style={{ color:'#6B7280',fontSize:13 }}>Loading...</p> : data.length === 0 ? (
          <p style={{ color:'#9CA3AF',fontSize:13,textAlign:'center',padding:20 }}>Belum ada riwayat approval</p>
        ) : (
          <div style={{ display:'flex',flexDirection:'column',gap:12 }}>
            {data.map((h, i) => (
              <div key={i} style={{ padding:12,background:'#F9FAFB',borderRadius:8,borderLeft:`3px solid ${h.aksi === 'REJECT' ? '#EF4444' : '#22C55E'}` }}>
                <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:6 }}>
                  {aksiBadge(h.aksi)}
                  <span style={{ fontSize:11,color:'#9CA3AF' }}>{new Date(h.dilakukan_at).toLocaleString('id-ID')}</span>
                </div>
                <div style={{ fontSize:12,color:'#374151' }}>
                  <strong>{h.nama_pelaku || 'System'}</strong>
                  <span style={{ color:'#6B7280' }}> — {h.status_dari || '-'} → {h.status_ke || '-'}</span>
                </div>
                {h.catatan && <div style={{ fontSize:12,color:'#6B7280',marginTop:4,fontStyle:'italic' }}>"{h.catatan}"</div>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
